import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../../apiclient/apiclient";
import OrderCard from "./OrderCard";
import socket from "../../../socket/socketClient";
import { ArrowLeft } from "lucide-react";
import PageHeader from "../../../components/PageHeader";
import Loader from "../../../components/Loader";
const ProcessingOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- LOAD PROCESSING ORDERS ---------------- */
  const loadOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get("/all-order?status=processing");

   // console.log("Delivered API response:", res.data); // 🔎 debug

    setOrders(res.data.data || []);
  } catch (error) {
    console.error("Error loading processing orders", error);
    setOrders([]);
  } finally {
    setLoading(false); // ✅ VERY IMPORTANT
  }
};


  useEffect(() => {
    loadOrders();
  }, []);

  /* 🔴 REALTIME UPDATE */
  useEffect(() => {
    const refresh = () => loadOrders();

    const events = [
      "order_accepted",        // pending → processing
      "order_collected",       // item collected
      "order_status_updated",  // shipped, delivered
      "order_updated",         // generic updates
    ];

    events.forEach(ev => socket.on(ev, refresh));

    return () => {
      events.forEach(ev => socket.off(ev, refresh));
    };
  }, []);

  return (
    <div className=" ">
      {/* HEADER */}
    <PageHeader
  title="Processing Orders"
  role="agent"
  subtitle="Orders currently being packed"
  variant="orange"   // same gradient you liked
  leftContent={
    <button onClick={() => navigate(-1)}>
      <ArrowLeft size={22} />
    </button>
  }
/>

 {loading ? (
  <Loader text="Loading processing orders..." />
) : orders.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No processing orders
  </p>
) : (
  <div className="space-y-4 p-3">
    {orders.map((order) => (
      <OrderCard
        key={order._id}
        order={order}
        reload={loadOrders}
      />
    ))}
  </div>
)}
    </div>
  );
};

export default ProcessingOrders;
